export const DOUBLE_CONSENT_SHOW = 'DOUBLE_CONSENT_SHOW';
export const DOUBLE_CONSENT_HIDE = 'DOUBLE_CONSENT_HIDE';
export const DOUBLE_CONSENT_AGREE = 'DOUBLE_CONSENT_AGREE';
export const DOUBLE_CONSENT_CANCEL = 'DOUBLE_CONSENT_CANCEL';
